import { TaskPriorityOptions } from 'shared/types/task-base';

export enum SortingMode {
  Custom = 'custom',
  DueDate = 'dueDate',
  Priority = 'priority',
  DeadlineDeadline = 'deadlineDeadline',
  CreatedAt = 'createdAt',
  Name = 'name',
  DeletedAt = 'deletedAt',
}

export enum HabitSortingMode {
  Custom = 'custom',
  Priority = 'priority',
}

export enum GoalSortingMode {
  StartDate = 'startDate',
  Deadline = 'deadline',
  Progress = 'progress',
  Custom = 'custom',
  Name = 'name',
  Tasks = 'tasks',
  Impact = 'impact',
}

export enum GroupByMode {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
  DayPart = 'dayPart',
  StartDate = 'startDate',
  Deadline = 'deadline',
  DeadlineDeadline = 'deadlineDeadline',
  Tag = 'tag',
  Section = 'section',
  CompletedDate = 'completedDate',
}

export type TaskGroupBy = Exclude<GroupByMode, GroupByMode.StartDate>;

export type GoalGroupBy =
  | GroupByMode.None
  | GroupByMode.LifeArea
  | GroupByMode.StartDate
  | GroupByMode.Deadline;

export enum TodayGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
  DayPart = 'dayPart',
}

export enum TagGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
}

export enum HabitGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
}

export enum OrderDirection {
  Asc = 'ascending',
  Desc = 'descending',
}

export const priorityRanking: Record<TaskPriorityOptions, number> = {
  [TaskPriorityOptions.High]: 0,
  [TaskPriorityOptions.Medium]: 1,
  [TaskPriorityOptions.Low]: 2,
  [TaskPriorityOptions.None]: 3,
};
